export class ApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public statusText: string,
    public details?: unknown,
    public headers: Record<string, string> = {}
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class ApiStreamInactivityError extends Error {
  constructor() {
    super('API_STREAM_INACTIVITY_TIMEOUT');
    this.name = 'ApiStreamInactivityError';
  }
}
